import React from 'react';
import { Select, MenuItem, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function SortBy({ onChange, items, value }: any) {
  return (
    <Select
      value={value || ''}
      onChange={(event: any) => onChange(event.target.value)}
      variant="outlined"
      sx={{ minWidth: { sm: '100%', md: '30%' } }}
    >
      {items.map((item: any) => (
        <MenuItem value={item.value} key={item.value}>
          <Typography sx={{ fontWeight: 'medium' }}>
            <FormattedMessage id={`SORT.${item.label}`} />
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
}

export default SortBy;
